import { Injectable } from '@angular/core';
import { EndpointService } from '../endpoints.service';
import { StorageService } from '../../@core/services/storage.service';
import {
  _AQH_EVE_120, _AQH_EVE_121, _AQH_EVE_122, _AQH_EVE_123, _AQH_EVE_124, _AQH_EVE_125,
  _AQH_EVE_126, _AQH_EVE_127, _AQH_EVE_128, _AQH_EVE_129,
  _AQH_EVE_130, _AQH_EVE_131, _AQH_EVE_132, _AQH_EVE_133, _AQH_EVE_134, _AQH_EVE_135,
  _AQH_EVE_136, _AQH_EVE_137,
  AQH_EVE_120, AQH_EVE_121, AQH_EVE_122, AQH_EVE_123, AQH_EVE_124, AQH_EVE_125,
  AQH_EVE_126, AQH_EVE_127, AQH_EVE_128, AQH_EVE_129,
  AQH_EVE_130, AQH_EVE_131, AQH_EVE_132, AQH_EVE_133, AQH_EVE_134, AQH_EVE_135,
  AQH_EVE_136, AQH_EVE_137,
  AQH_EVE_142, AQH_EVE_143, AQH_EVE_144
} from '../models/input.module';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScoringService {

  constructor(
    private endpointService: EndpointService,
    private storageService: StorageService
  ) {}

  // Scoring Config
  getScoringConfig(params: _AQH_EVE_120) {
    const payload: AQH_EVE_120 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_120(payload).pipe(map(data => data.data));
  }

  saveScoringConfig(params: _AQH_EVE_121) {
    const payload: AQH_EVE_121 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_121(payload).pipe(map(data => data.data));
  }

  // Penalty Presets
  getPenaltyPresets(params: _AQH_EVE_122) {
    const payload: AQH_EVE_122 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_122(payload).pipe(map(data => data.data));
  }

  addPenaltyPreset(params: _AQH_EVE_123) {
    const payload: AQH_EVE_123 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_123(payload).pipe(map(data => data.data));
  }

  updatePenaltyPreset(params: _AQH_EVE_124) {
    const payload: AQH_EVE_124 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_124(payload).pipe(map(data => data.data));
  }

  deletePenaltyPreset(params: _AQH_EVE_125) {
    const payload: AQH_EVE_125 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_125(payload).pipe(map(data => data.data));
  }

  // Rounds
  getRounds(params: _AQH_EVE_126) {
    const payload: AQH_EVE_126 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_126(payload).pipe(map(data => data.data));
  }

  createRound(params: _AQH_EVE_127) {
    const payload: AQH_EVE_127 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_127(payload).pipe(map(data => data.data));
  }

  updateRound(params: _AQH_EVE_128) {
    const payload: AQH_EVE_128 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_128(payload).pipe(map(data => data.data));
  }

  deleteRound(params: _AQH_EVE_129) {
    const payload: AQH_EVE_129 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_129(payload).pipe(map(data => data.data));
  }

  // Results
  getResults(params: _AQH_EVE_130) {
    const payload: AQH_EVE_130 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_130(payload).pipe(map(data => data.data));
  }

  createResult(params: _AQH_EVE_131) {
    const payload: AQH_EVE_131 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_131(payload).pipe(map(data => data.data));
  }

  updateResult(params: _AQH_EVE_132) {
    const payload: AQH_EVE_132 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_132(payload).pipe(map(data => data.data));
  }

  deleteResult(params: _AQH_EVE_133) {
    const payload: AQH_EVE_133 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_133(payload).pipe(map(data => data.data));
  }

  applyPenalties(params: _AQH_EVE_134) {
    const payload: AQH_EVE_134 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_134(payload).pipe(map(data => data.data));
  }

  getResultByEntry(params: _AQH_EVE_135) {
    const payload: AQH_EVE_135 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_135(payload).pipe(map(data => data.data));
  }

  // Final Positions
  getFinalPositions(params: _AQH_EVE_136) {
    const payload: AQH_EVE_136 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_136(payload).pipe(map(data => data.data));
  }

  saveFinalPositions(params: _AQH_EVE_137) {
    const payload: AQH_EVE_137 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.aqh_eve_137(payload).pipe(map(data => data.data));
  }

  // Result Images
  uploadResultImage(params: AQH_EVE_142) {
    return this.endpointService.aqh_eve_142(params).pipe(map(data => data.data));
  }

  getResultImages(params: AQH_EVE_143) {
    return this.endpointService.aqh_eve_143(params).pipe(map(data => data.data));
  }

  deleteResultImage(params: AQH_EVE_144) {
    return this.endpointService.aqh_eve_144(params).pipe(map(data => data.data));
  }
}
